import { Group, Title } from '@mantine/core';
import React from 'react';
import DataTable from 'react-data-table-component';
import ActionCell from './components/ActionCell';
import useGetCustomPage from './useGetCustomPage';
import { useNavigate } from "react-router-dom";
import LoadingErrorContainer from '../../components/placeholders/LoadingErrorContainer';

const Remote = () => {
    const navigate = useNavigate();
    const { CustomPageQuery: {
        data, isPending, isError, isRefetching },
        totalRows,
        handleChangePerPage,
        handlePageChange,
    } = useGetCustomPage()


    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,

        },


        {
            name: 'Action',
            cell: row => <ActionCell row={row} />,


        },
    ];



    return (
        <LoadingErrorContainer
            isError={isError}
            isLoading={isPending}
            isRefetching={isRefetching}
        >
            <Group justify='space-between'>
                <Title order={3}>CustomPage</Title>

            </Group>
            <DataTable
                columns={columns}
                data={data ?? []}
                progressPending={isPending}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handleChangePerPage}
                onChangePage={handlePageChange}



            // selectableRows

            />

        </LoadingErrorContainer>


    );

}

export default Remote;
